import { vehiclesApi } from '@repo/api'
import { useQuery } from '@tanstack/react-query'

import type { TrailerWithVehicleResponse } from '@repo/api'

export const useTrailers = (params?: {
  unassignedOnly?: boolean
  includeTrailerId?: number
}) => {
  return useQuery({
    queryKey: [
      'vehicles',
      'trailers',
      params?.unassignedOnly ?? false,
      params?.includeTrailerId ?? null,
    ],
    queryFn: async (): Promise<Array<TrailerWithVehicleResponse>> => {
      return vehiclesApi.getTrailers(params)
    },
  })
}
